import {
  lg,
  cloneDeep,
  util,
  isCorrectVal,
  isDate
} from 'utils';
import NProgress from 'nprogress';
import $http from '$http';
export default {

  methods: {

    getList() {
      var params = {
        Sid: this.$store.state.sysSid,
        Session: this.$store.state.sysSession,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      for (let item in this.query) {
        let value = this.query[item];
        if (value !== '') {
          // 去除空格trimAllSpace(str, is_global)  true 为去除所有空格
          if (typeof value == 'string') {
            value = util.trimAllSpace(value);
          }
          this.query[item] = value
          params[item] = value;
          if (item == "ShelfTimeStart" || item == "ShelfTimeEnd") {
            params[item] = util.time2str(value);
          }
        }
      }
      this.lists = [];
      this.loading = true; //拼命加载中显示
      $http.get('api/Memorandum/GetMemorandum_List', params).then(res => {
        let {
          StateCode,
          StateMsg,
          Data,
          Cnt
        } = res.data;
        util.doResult(this, res, () => {
          this.loading = false; //拼命加载中隐
          this.lists = Data;

          for (let i = 0; i < this.lists.length; i++) {
            let arr = []
            if (this.lists[i].DeductibleOrder.length > 0) {
              for (let j = 0; j < this.lists[i].DeductibleOrder.length; j++) {
                arr.push(this.lists[i].DeductibleOrder[j].Name)
              }
              this.lists[i].DeductibleOrderList = arr.join(', ')
            } else {
              this.lists[i].DeductibleOrderList = '该套餐不支持任何账户抵扣'
            }
          }
          this.totalSize = Cnt;
        });
      });
    },


  }
}


// WEBPACK FOOTER //
// ./src/pages/Memorandum/PackageRule/services.js